export default __webpack_public_path__ + "static/media/gesundheitServicekleidung.3a1e50e9.jpg";